import React, { HTMLAttributes } from "react";
import { tx } from "netbank-shared/src/libs/i18n";
import styles from "./CloseButton.scss";
import classNames from "classnames";

interface IModalProps extends HTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
  loading?: boolean;
  dark?: boolean;
}

export const CloseButton = (props: IModalProps) => {
  const { onClick, loading, dark, className, ...rest } = props;

  return (
    <button
      type="button"
      onClick={loading ? undefined : onClick}
      className={classNames(className, styles.closeWrapper, {
        [styles.dark]: dark,
        [styles.loading]: loading,
      })}
      aria-label={tx("misc.close")}
      {...rest}
    >
      {loading ? (
        <div className={styles.loading} />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M1.05469 10.9498L10.9542 1.05027"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9531 10.9498L1.05363 1.05027"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
};
